import gql from 'graphql-tag';

export const selectedThemeQuery = gql`
  query selectedThemeQuery {
    theme {
      id
      previewImage {
        mediaApiId
      }
      name
      designerUrl
      family
      themeDesigner {
        name
        companyName
      }
      stationaryPreviewImage {
        mediaApiId
      }
    }
  }
`;

export const selectedThemeMutation = gql`
  mutation selectedThemeMutation($id: Int!) {
    updateSelectedTheme(id: $id) {
      id
      previewImage {
        mediaApiId
      }
      name
      designerUrl
      family
      themeDesigner {
        name
        companyName
      }
      stationaryPreviewImage {
        mediaApiId
      }
    }
  }
`;
